import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/providers.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/navigation/HiddenMenu.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/navigation/LanguageToggle.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/navigation/ScrollToTop.tsx")